module.exports = __webpack_public_path__ + "img/logo_be_vallet_pnud.8a887582.png";